module.exports = __webpack_public_path__ + "media/images/viacap_logo-4c607f0a0046b36dd827ee307c4e90ae.png";